<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import { httpServices } from '@utils/http-services'
import { hasErrors } from '@utils/form'
import { timezones } from '@utils/timezones'

export default {
  page: {
    title: 'Create Hardware',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      hasErrors,
      hardwares: null,
      orgs: null,
      show: false,
      timezones: timezones,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    httpServices.getHardwares().then((res) => {
      this.hardwares = res
    })
    httpServices.getOrgs().then((res) => {
      this.orgs = res
    })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = {
            hardwareId: values.id.toLowerCase(),
            orgId: values.orgId,
            meta: {
              orgId: values.orgId,
              serial: values.serial,
              location: values.location,
              timezone: values.timezone,
              id: values.id,
            },
          }
          httpServices.createHardware(data).then(
            () => {
              this.$notification.success({
                message: `Successfully Created Hardware: ${values.id}`,
              })
              this.$router.push({
                name: 'sim-management',
              })
            },
            () => {
              this.$notification.error({
                message: `Failed to Create Hardware: That Hardware ID already exists.`,
              })
            }
          )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/sim-management">
              <a-icon type="phone" />
              <span>SIM Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="plus-square" />
            Add New Hardware
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="plus-square" style="padding-right: 4px" />
            Add New Hardware
          </h4>
        </div>

        <template>
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="Hardware Meta Data">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="16" :md="6">
                        <a-form-item label="ID">
                          <a-input
                            v-decorator="[
                              'id',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your hardware id!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="Location">
                          <a-input
                            v-decorator="[
                              'location',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your hardware location!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="Serial">
                          <a-input
                            v-decorator="[
                              'serial',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your hardware serial number!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="Select a Timezone">
                          <a-select
                            v-decorator="[
                              'timezone',
                              {
                                rules: [
                                  {
                                    required: true,
                                  },
                                ],
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(tz, i) in timezones"
                              :key="i"
                              :value="tz.value"
                            >
                              {{ tz.value }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Select an Organization">
                          <a-select
                            v-decorator="[
                              'orgId',
                              {
                                rules: [
                                  {
                                    required: true,
                                  },
                                ],
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(org, i) in orgs"
                              :key="i"
                              :value="org.pk.replace('ORG#', '')"
                            >
                              {{ org.pk.replace('ORG#', '').toUpperCase() }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button
                      type="primary"
                      html-type="submit"
                      :disabled="hasErrors(form.getFieldsError())"
                    >
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
      </div>
    </div>
  </Layout>
</template>
